import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type CreateSitesAndCostCentersViaCSVResponse } from './types';
import { zodCreateSitesAndCostCentersViaCSVResponseSchema } from './validations';

/**
 * Creates sites together with their cost centers from a CSV file.
 *
 * @param file - The CSV file with one site and its cost centers per row.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The ids of the written sites, the server's message and, from API
 *   versions that update sites by `sync_key`, the created, updated and skipped
 *   rows.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Admin/operation/create_sites_and_cost_center_via_csv_admin_site_cc_csv_post
 */
export const createSitesAndCostCentersViaCSV = async (
  file: File,
  options?: KyRequestOptions,
) => {
  const formData = new FormData();
  formData.append('cs_cc_data', file);

  return await vestigasApi
    .post(ENDPOINT.SITE.CREATE_SITES_AND_COST_CENTERS_VIA_CSV(), {
      ...options,
      body: formData,
      validate: {
        ...options?.validate,
        response: zodCreateSitesAndCostCentersViaCSVResponseSchema,
      },
    })
    .json<CreateSitesAndCostCentersViaCSVResponse>();
};
